var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "162px",
    height: "162px",
    viewBox: "0 0 50 50",
    id: "Message_And_Communication_Icons",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "25.3,30.2 37.5,22.4 37.5,25.3 25.3,33 ",
    style: {
      fill: "#4DE0F9"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "35.3,25.4 32.6,27.1 32.6,11 35.3,11 ",
    style: {
      fill: "#4DE0F9"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 3.9,
    style: {
      fill: "#4DE0F9"
    },
    width: 16.1,
    x: 25.3,
    y: 38.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "37.2,26.9 41.4,24.1 41.4,42.8 37.2,42.8 ",
    style: {
      fill: "#4DE0F9"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "40.5,41.7 10,41.7 10,22.5 11.2,22.5 11.2,40.5 39.3,40.5 39.3,22.5 40.5,22.5 ",
    style: {
      fill: "#0D5FC3"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.3,32.4c-0.1,0-0.2,0-0.3-0.1L10.3,23c-0.2-0.1-0.3-0.3-0.3-0.5s0.1-0.4,0.3-0.5l5.7-3.6l0.6,1 l-4.9,3.1l13.5,8.6l13.5-8.6l-4.9-3.1l0.6-1l5.7,3.6c0.2,0.1,0.3,0.3,0.3,0.5s-0.1,0.4-0.3,0.5l-14.6,9.3 C25.5,32.4,25.4,32.4,25.3,32.4z",
    style: {
      fill: "#0D5FC3"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 4.6,
    style: {
      fill: "#4DE0F9"
    },
    width: 1.5,
    x: 12.8,
    y: 34.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 1.5,
    style: {
      fill: "#4DE0F9"
    },
    width: 1.5,
    x: 12.8,
    y: 31.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "34.8,26.2 33.6,26.2 33.6,9.8 17,9.8 17,26 15.8,26 15.8,8.6 34.8,8.6 ",
    style: {
      fill: "#0D5FC3"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "25.3,32.5 19.6,29 20.3,27.9 25.3,31.1 30.5,27.8 31.2,28.8 ",
    style: {
      fill: "#0D5FC3"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.8,22.9h-1.5c-0.5,0-1-0.4-1-1v-1.3H24c-0.5,0-1-0.4-1-1v-2.3c0-0.5,0.4-1,1-1h2.5 c0.5,0,1,0.4,1,1v4.3h1.1V15h-6.6v6.6H25v1.2h-3.3c-0.5,0-1-0.4-1-1v-7.1c0-0.5,0.4-1,1-1h7.1c0.5,0,1,0.4,1,1v7.1 C29.8,22.4,29.3,22.9,28.8,22.9z M24.3,19.4h2v-1.8h-2V19.4z",
    style: {
      fill: "#0D5FC3"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.dece6910b1df87edd0c0cfd245a22a2f.svg";
export { ForwardRef as ReactComponent };